<svg
    width="301"
    height="220"
    viewBox="0 0 301 220"
    xmlns="http://www.w3.org/2000/svg">
    <!-- Roof -->
    <svg:path
        class="outer-roof"
        d="M0 101 L178 208 L299 135 L122 28 L0 101 Z" />
    <svg:path
        d="M8 100 L179 202 L291 135 L122 33 L8 100 Z"
        [attr.fill]="'var(--roof-bg)'" />
    <g
        [x]="-90"
        [y]="10"
        app-roof-box></g>
    <g
        [x]="-30"
        [y]="-30"
        app-roof-box></g>
    <g
        [width]="250"
        [height]="250"
        [x]="130"
        [y]="-10"
        app-roof-vent></g>
    <g
        [width]="250"
        [height]="250"
        [x]="85"
        [y]="20"
        app-roof-vent></g>
</svg>
